// src/components/ui/Card.tsx
import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: "sm" | "md" | "lg";
  hover?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = "",
  padding = "md",
  hover = false,
  onClick
}) => {
  const paddingClasses = {
    sm: "p-4",
    md: "p-6", 
    lg: "p-8"
  };

  const hoverClasses = hover 
    ? "hover:shadow-lg hover:-translate-y-1 transition-all duration-200 cursor-pointer"
    : "";

  return (
    <div 
      className={`
        bg-white rounded-lg shadow-sm border border-gray-200 
        ${paddingClasses[padding]} 
        ${hoverClasses} 
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;